const SWIPER_TOP_PC = document.querySelector("#custom-top-kv-pc");
const SWIPER_TOP_PC_SLIDE_SPEED = SWIPER_TOP_PC.dataset.slideSpeed;

new Swiper(SWIPER_TOP_PC, {
  loop: true, // ループ
  speed: 1500, // 少しゆっくり(デフォルトは300)
  slidesPerView: 1.9, // 一度に表示する枚数
  centeredSlides: true, // アクティブなスライドを中央にする
  autoplay: {
    // 自動再生
    delay: SWIPER_TOP_PC_SLIDE_SPEED * 1000, // 1秒後に次のスライド
    disableOnInteraction: false, // 矢印をクリックしても自動再生を止めない
  },
  // ページネーション
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
});
